import { render, staticRenderFns } from "./HelpCenter.vue?vue&type=template&id=7506cbd0&scoped=true&"
import script from "./HelpCenter.vue?vue&type=script&setup=true&lang=js&"
export * from "./HelpCenter.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./HelpCenter.vue?vue&type=style&index=0&id=7506cbd0&prod&scoped=true&lang=css&"
import style1 from "./HelpCenter.vue?vue&type=style&index=1&id=7506cbd0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7506cbd0",
  null
  
)

export default component.exports